import React from 'react';
import { BorderStyled } from './styles';

const Border = ({ style }) => <BorderStyled style={style} />;

export default Border;
